// Lightweight, dependency-free cookie-consent store (GDPR-style).
// Consent itself is "strictly necessary" state, kept in localStorage on this device.
export const CONSENT_KEY = "pe_cookie_consent";
export const CONSENT_VERSION = 1;

export const getConsent = () => {
    try {
        const c = JSON.parse(localStorage.getItem(CONSENT_KEY));
        return c && c.version === CONSENT_VERSION ? c : null;
    } catch {
        return null;
    }
};

export const setConsent = (functional) => {
    const value = {
        version: CONSENT_VERSION,
        essential: true,
        functional: !!functional,
        ts: new Date().toISOString(),
    };
    localStorage.setItem(CONSENT_KEY, JSON.stringify(value));
    // Withdrawing functional consent must remove the preference cookie it set.
    if (!functional) document.cookie = "pe_school_route=; path=/; max-age=0";
    window.dispatchEvent(new CustomEvent("pe-consent-changed", { detail: value }));
    return value;
};

export const hasFunctionalConsent = () => !!getConsent()?.functional;

// Lets any page (e.g. a footer link) reopen the preferences dialog.
export const openCookiePreferences = () => window.dispatchEvent(new CustomEvent("pe-open-cookie-prefs"));
